import React from "react";
import Reveal from "./Reveal";
import { PROCESS } from "../../data/content";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="section-pad relative z-10 bg-[#0c0c0b]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="text-center mb-16">
          <div className="overline mb-4">How I Work</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight">
            The Entrepreneurial <span className="text-amber">Approach.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROCESS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.08} className="relative">
              <div className="font-mono text-6xl font-bold text-white/[0.06]">{step.num}</div>
              <div className="h-px w-full bg-white/10 my-5 relative">
                <div className="absolute left-0 top-0 h-px w-8 bg-amber" />
              </div>
              <h3 className="font-display text-2xl font-medium mb-3">{step.title}</h3>
              <p className="text-ink-secondary leading-relaxed text-[0.95rem]">{step.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
